import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import tokens from '../theme/tokens';

// 단계별 예상 소요시간 — 기사 배정 → 픽업지로 이동 → 픽업 → 출발지→도착지 → 도착 후 전달. 서버(webEta)가 차량별로 계산한 timeline 을 그린다.
// 머리에 '지금 접수하면 도착 예상 HH:MM~HH:MM · 총 거리 · 총 시간'
const useStyles = makeStyles(() => ({
  root: { marginTop: 12 },
  head: {
    display: 'flex', flexWrap: 'wrap', alignItems: 'baseline', gap: '2px 10px', marginBottom: 10,
    '& b': { fontSize: 15, fontWeight: 700, letterSpacing: -0.6, color: tokens.primaryDark },
    '& span': { fontSize: 13, letterSpacing: -0.4, color: tokens.text },
  },
  list: { borderRadius: 10, border: `1px solid ${tokens.line}`, backgroundColor: tokens.surface, overflow: 'hidden' },
  step: {
    display: 'flex', alignItems: 'center', minHeight: 46, padding: '6px 14px 6px 12px',
    '& + &': { borderTop: `1px solid ${tokens.lineSoft}` },
  },
  num: {
    flex: 'none', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 22, height: 22, marginRight: 10, borderRadius: 11,
    border: `1px solid ${tokens.primaryLine}`, backgroundColor: tokens.primarySoft, color: tokens.primaryDark, fontSize: 11, fontWeight: 700,
  },
  numOn: { backgroundColor: tokens.primary, borderColor: tokens.primary, color: tokens.surface },
  text: { flex: '1 1 auto', minWidth: 0 },
  label: { fontSize: 13, fontWeight: 700, letterSpacing: -0.4, color: tokens.ink },
  note: { marginTop: 1, fontSize: 11, letterSpacing: -0.3, color: tokens.muted },
  val: { flex: 'none', marginLeft: 10, textAlign: 'right', fontSize: 13, fontWeight: 700, letterSpacing: -0.4, color: tokens.ink, '& small': { display: 'block', fontSize: 11, fontWeight: 400, color: tokens.muted } },
  dim: { color: tokens.muted, fontWeight: 400 },
}));

const hhmm = (iso) => { const d = new Date(iso); return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`; };
const range = (arr) => (Array.isArray(arr) ? (arr.length > 1 && arr[0] !== arr[1] ? `${arr[0]}~${arr[1]}분` : `${arr[0]}분`) : '');

function VehicleCheckTimeline({ timeline, vehicle, className }) {
  const cs = useStyles();
  if (!timeline) return null;
  const { steps = [], totalKm, totalMin, eta = [] } = timeline;
  return (
    <div className={clsx(cs.root, className)}>
      <div className={cs.head}>
        {eta.length === 2 && <b>지금 접수하면 {hhmm(eta[0])}~{hhmm(eta[1])} 도착 예상</b>}
        <span>{vehicle ? `${vehicle} 기준 · ` : ''}{totalKm != null ? `총 약 ${totalKm}km · ` : ''}약 {range(totalMin)}</span>
      </div>
      <div className={cs.list}>
        {steps.map((s, i) => (
          <div key={s.key} className={cs.step}>
            <span className={clsx(cs.num, s.key === 'travel' && cs.numOn)}>{i + 1}</span>
            <span className={cs.text}>
              <span className={cs.label}>{s.label}</span>
              {s.note && <div className={cs.note}>{s.note}</div>}
            </span>
            <span className={clsx(cs.val, !s.min && cs.dim)}>
              {s.min ? `약 ${range(s.min)}` : '-'}
              {s.km != null && <small>{s.key === 'toPickup' ? '평균 ' : ''}{s.km}km</small>}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default VehicleCheckTimeline;
